export default {
    data() {
        return {
            registerForm: this.$form.createForm(this, {
                onFieldsChange: (_, changedFields) => {
                    if (Object.keys(changedFields)[0] !== 'code') {
                        this.show = false
                    }
                    const values = this.registerForm.getFieldsValue()
                    this.isDisable = Object.keys(values).some(v => !values[v])
                },
            }),
            isDisable: true,
            show: true
        }
    }
}